
import XButton from 'vux/src/components/x-button/index.vue'

import {
PageContainer,
PageHeader,
PageContent,
PageFooter,
} from '@/common/components/index'
import { mapState } from 'vuex'

import {service} from '@/common/index'
import nativeApi from '@/common/tool/sdk2/nativeApi'




export default {
data () {
return {

}
},
components: {
PageContainer,
PageHeader,
PageContent,
PageFooter,
XButton,
},
computed: {
...mapState({
userInfo: state => state.user.userInfo,
guideInfo: state => state.user.guideInfo,
shopInfo: state => state.user.shopInfo,
orgInfo: state => state.user.orgInfo,
deviceInfo: state => state.user.deviceInfo,
custom: state => state.custom,
}),
},
created(){

},
methods: {
},
watch:{
},
mounted(){

},
}




// WEBPACK FOOTER //
// ./src/page/demo/ContentBox.vue